"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicBrevoContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.publicBrevoContract = c.router({
    processWebhook: {
        method: 'POST',
        path: '/process-webhook',
        body: zod_1.z.any(),
        responses: {
            200: zod_1.z.string(),
        },
        summary: 'Webhook called by Brevo',
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=brevo.public.contract.js.map